module.exports = __webpack_public_path__ + "img/mail.5e2ce559.svg";